import { createCategoriesApi } from "@/v2/api/metadata/categories";
import { createPlayersApi } from "@/v2/api/metadata/players";
import { createSportsApi } from "@/v2/api/metadata/sports";
import { createTeamsApi } from "@/v2/api/metadata/teams";
import { createTournamentsApi } from "@/v2/api/metadata/tournaments";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createFilters } from "./filters";
import { createDialogs } from "./dialogs";

const LS_PLAYERS_FILTERS_KEY = Symbol("players-filters");

export function createPlayersView(ctx: BackofficeContext): EntityView {
  const playersApi = createPlayersApi(ctx);
  const sportsApi = createSportsApi(ctx);
  const categoriesApi = createCategoriesApi(ctx);
  const tournamentsApi = createTournamentsApi(ctx);
  const teamsApi = createTeamsApi(ctx);

  return {
    id: "players",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx, sportsApi, categoriesApi, tournamentsApi, teamsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({
          ctx,
          playersApi,
          sportsApi,
          categoriesApi,
          tournamentsApi,
          teamsApi,
        }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_PLAYERS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: playersApi.grid,
      },
    ],
  };
}
